import { AddCashModal, FlatListWrapper, View } from '../../../component';
import { ContestShare, ContestConfirmModal } from '../../component';
import FlatList from 'flatlist-react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import ContestSortingHeaderMWeb from '../../component/contest_sorting_header/index_mWeb';
import ContestFilterMWeb from '../../component/contest_filter/index_mWeb';
import ContestListHeaderMWeb from '../../component/contest_list_header/index_mWeb';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const ContestListTabMWeb = ({
  onPressFilter,
  onPressEntryFee,
  onPressPrizePool,
  onPressSpots,
  onPressCard,
  onPressShare,
  contestCategoryList,
  matchStatus,
  gameState,
  totalTeamsCount,
  matchItem,
  matchDelayed,
  gameType,
  onApplyFilter,
  onClearFilter,
  contestFilterVisible,
  onPressFilterDismiss,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  showAllContest,
  onPressJoinContest,
  onPressJoin,
  onPressWinners,
  contestConfirmModal,
  onPressDismissContestConfirm,
  entryFee,
  bonusPercentage,
  balance,
  addCashVisible,
  onPressDismissCashModal,
  onRefresh
}: any) => {
  const renderItem = (item: any) => {
    return (
      <>
        <View key={item.header.id}>
          <ContestListHeaderMWeb
            contestCategory={item.header}
            key={item.header._id}
            contestCount={item.header.contestCount}
            onPressViewAll={showAllContest}
          />
        </View>
        {item.data.map((item: any) => (
          <ContestCardMWeb
            key={item._id}
            contest={item}
            onPressCard={() => onPressCard(item)}
            onPressShare={() => onPressShare()}
            matchStatus={matchStatus}
            gameState={gameState}
            totalTeamsCount={totalTeamsCount}
            matchItem={matchItem}
            screenName={'CONTEST_LIST'}
            matchDelayed={matchDelayed}
            gameType={gameType}
            onPressJoin={() => onPressJoin(item)}
          />
        ))}
      </>
    );
  };

  return (
    <ScreenBackgroundWrapper>
      <ContestSortingHeaderMWeb
        onPressFilter={onPressFilter}
        onPressEntryFee={onPressEntryFee}
        onPressPrizePool={onPressPrizePool}
        onPressSpots={onPressSpots}
        onPressWinner={onPressWinners}
      />

      <PullToRefresh onRefresh={onRefresh}>
        <FlatListWrapper className={'flat-list-padding'}>
          <FlatList list={contestCategoryList} renderItem={renderItem} renderOnScroll />
        </FlatListWrapper>
      </PullToRefresh>
      <ContestFilterMWeb
        onApplyFilter={onApplyFilter}
        onClearFilter={onClearFilter}
        visible={contestFilterVisible}
        onPressDismiss={onPressFilterDismiss}
      />
      <ContestShare
        link={contestLink}
        contestTitle={contestTitle}
        visible={contestShare}
        onPressDismiss={onPressShareModalDismiss}
      />
      <ContestConfirmModal
        visible={contestConfirmModal}
        onPressDismiss={onPressDismissContestConfirm}
        entryFee={entryFee / 100}
        selectedTeamCount={1}
        joinContest={onPressJoinContest}
        bonusPercentage={bonusPercentage}
      />
      <AddCashModal
        totalAmount={balance['totalBalance']}
        visible={addCashVisible}
        onPressDismiss={onPressDismissCashModal}
      />
    </ScreenBackgroundWrapper>
  );
};

export default ContestListTabMWeb;
